import type { MessageTemplate } from '../../types';
import { useT } from '../../i18n';
import styles from './SearchbarInitialScreen.module.css';

export interface SearchbarInitialScreenProps {
  /** Section heading (defaults to the localized "Start here") */
  heading?: string;
  /** Configured logo shown to the left of the heading (null = bullet dot) */
  logoUrl?: string | null;
  /** Templates rendered as 2-column cards */
  messageTemplates: MessageTemplate[];
  onTemplateClick: (template: MessageTemplate) => void;
}

export function SearchbarInitialScreen({
  heading,
  logoUrl = null,
  messageTemplates,
  onTemplateClick,
}: SearchbarInitialScreenProps) {
  const t = useT();

  if (!messageTemplates.length) return null;

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        {logoUrl ? (
          <img src={logoUrl} alt="" className={styles.headingLogo} draggable={false} />
        ) : (
          <span className={styles.headingDot} aria-hidden="true" />
        )}
        {heading ?? t('searchbar.startHere')}
      </div>
      <div className={styles.grid}>
        {messageTemplates.map((template, index) => (
          <button
            key={`${template.search_query || template.form_id || 'template'}-${index}`}
            type="button"
            className={styles.card}
            onClick={() => onTemplateClick(template)}
            aria-label={template.label}
          >
            {template.emoji ? (
              <span className={styles.cardEmoji}>
                {template.emoji.startsWith('http') ? (
                  <img src={template.emoji} alt="" className={styles.cardEmojiImg} draggable={false} />
                ) : (
                  template.emoji
                )}
              </span>
            ) : (
              <span className={styles.cardEmoji} aria-hidden="true">
                ✨
              </span>
            )}
            <span className={styles.cardLabel}>{template.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
